import { render } from "./SearchFilterCategory.vue?vue&type=template&id=3781089a"
import script from "./SearchFilterCategory.vue?vue&type=script&lang=js"
export * from "./SearchFilterCategory.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__